import { useRef, useState, useEffect } from "react";

export default function useAfterFetch<T>(
    isFetching: boolean | undefined,
    error: string | null | undefined,
    callback: () => T,
    dependencies: any[] = []
): [T, React.MutableRefObject<boolean>] {
    const [result, setResult] = useState<any>();
    const hasSubmitted = useRef(false);

    useEffect(() => {
        if (!isFetching && !error && hasSubmitted.current) {
            setResult(callback());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFetching, error, ...dependencies]);

    return [result, hasSubmitted];
}
